// функция скачивания файла
const downloadFile = (data: string | Blob, name: string, isUrl: boolean = false): void => {
	let url: string = "";

	if (typeof data === "string") {
		if (isUrl) url = data;
		else {
			const file = new File([data], name);
			url = window.URL.createObjectURL(file);
		}
	} else {
		url = window.URL.createObjectURL(data);
	}

	const link = document.createElement("a");
	link.href = url;
	link.setAttribute("download", name);
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
	URL.revokeObjectURL(url);
};

export default downloadFile;
